import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Chart from "react-apexcharts";
import { generateSymbolColors } from "../../../components/chartColor";
import BlurredText from "../../../components/BlurText";
import {
  addPortfolioApi,
  getSampleServiceApi,
  getServiceApi,
} from "../../../redux/portfolio/portfolio";
import toast from "react-hot-toast";
import Layout from "../../layout/Layout";
import moment from "moment";
import { useTheme } from "../../../utils/theme";

function MPortfolio() {
  const { theme } = useTheme();
  const dispatch = useDispatch();
  const portFolioList = useSelector(
    (state) => state.portfolio.sampleportFolioList,
  );
  const blurLegends = () => {
    const legends = document.querySelectorAll(".apexcharts-legend-text");
    legends.forEach((el) => {
      el.textContent = "xxxxxxxx";
      el.style.filter = "blur(4px)";
      el.style.userSelect = "none";
      el.style.fill = theme === "dark" ? "#e5e7eb" : "#374151";
      el.style.color = theme === "dark" ? "#e5e7eb" : "#374151";
    });
  };
  useEffect(() => {
    dispatch(getSampleServiceApi());
  }, []);

  const symbols = portFolioList?.stocks?.map((item) => item.symbol) || [];
  const userDetail = useSelector((state) => state.auth.userDetail);
  const symbolColors = generateSymbolColors(symbols);

  const userPortfolio = useSelector(
    (state) => state.portfolio.sampleportFolioList,
  );
  const [highlightIndex, setHighlightIndex] = useState(null);
  const [editIndex, setEditIndex] = useState(null);
  const [selectedindex, setSelectedindex] = useState(null);
  const [inputs, setInputs] = useState({});
  const [errors, setErrors] = useState({});
  const [chartData, setChartData] = useState({
    series: [],
    options: {
      dataLabels: {
        enabled: false,
      },
      tooltip: {
        enabled: false,
      },
      chart: {
        type: "pie",
        events: {
          mounted: () => {
            blurLegends();
          },
          updated: () => {
            blurLegends();
          },
        },
      },
      plotOptions: {
        pie: {
          // Offset the whole pie chart
          offsetX: 0,
          offsetY: 20,
          donut: {
            size: "70%", // Adjust donut size for inner space
            labels: {
              show: false, // Show inner labels
              name: {
                show: false,
                fontSize: "16px",

                // ... other label styles
              },
              value: {
                show: false,
                fontSize: "14px",
                formatter: (val) =>
                  Number(val).toLocaleString("en-IN", {
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1,
                  }),
                // ... other label styles
              },
            },
          },

          dataLabels: {
            offset: 10,

            // Distance of data labels from pie edge
            // ... other dataLabel settings
          },
        },
      },
    },
  });
  const [addedRows, setAddedRows] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [finalData, setFinalData] = useState(false);
  const handleInputChange = (index, field, value, recomQty) => {
    const numValue = Number(value);
    setSelectedindex(index ? index : null);
    if (numValue < 0) {
      setErrors((prev) => ({
        ...prev,
        [index]: {
          ...prev[index],
          [field]: "Value cannot be negative",
        },
      }));
      return; // stop here, don't update inputs
    }

    // if (recomQty && numValue > Number(recomQty) && field != "price") {
    //   // ❌ Greater than recommended qty not allowed
    //   setErrors((prev) => ({
    //     ...prev,
    //     [index]: {
    //       ...prev[index],
    //       [field]: `Value should not exceed ${recomQty}`,
    //     },
    //   }));
    //   return; // stop here, don't update inputs
    // }

    // ✅ Passed validation → update inputs and clear errors
    setInputs((prev) => ({
      ...prev,
      [index]: {
        ...prev[index],
        [field]: value,
      },
    }));

    setErrors((prev) => ({
      ...prev,
      [index]: {
        ...prev[index],
        [field]: "",
      },
    }));
  };
  const handleAdd = async (stock, index, isInitial, mode) => {
    const stockInput = inputs[index] || {};
    // const qty = parseFloat(stockInput.qty);
    // const price = parseFloat(stockInput.price);
    // const qty = parseFloat(String(stockInput.qty || "").replace(/,/g, ""));
    const price = parseFloat(String(stockInput.price || "").replace(/,/g, ""));
    let isValid = true;
    const validationErrors = {};

    // if (!qty || isNaN(qty) || qty <= 0) {
    //   validationErrors.qty = "Enter a valid quantity";
    //   isValid = false;
    // }
    // if (!qty || isNaN(qty) || qty <= stock.qty) {
    //   validationErrors.qty = "Enter a valid quantity";
    //   isValid = false;
    // }

    if (!price || isNaN(price) || price <= 0) {
      validationErrors.price = "Enter a valid buying price";
      isValid = false;
    }

    if (!isValid) {
      setErrors((prev) => ({
        ...prev,
        [index]: validationErrors,
      }));
      return;
    }

    // Clear errors
    setErrors((prev) => ({
      ...prev,
      [index]: {},
    }));

    // Build final data
    const finalData = {
      investedAmt: price * (stock.qty || stock?.recQty),
      allocation: stock.allocation,
      portfolioId: isInitial ? stock.portfolioId : stock.id,
      coCode: stock.coCode,
      symbol: stock.symbol,
      avgPrice: price,
      qty: stock.qty || stock?.recQty,
      isInitial: isInitial,
      id: stock.id,
    };
    setFinalData(finalData);
    setShowModal(true);

    // ✅ Mark row as added so it won’t show Add button again
    if (mode === "add") {
      setAddedRows((prev) => ({ ...prev, [index]: true }));
    }

    // Clear inputs after action
    setInputs((prev) => {
      const updated = { ...prev };
      delete updated[index];
      return updated;
    });
  };
  const handleSave = async (finalData) => {
    try {
      const result = await dispatch(addPortfolioApi(finalData));
      if (result) {
        dispatch(getServiceApi(userDetail?.id));
        toast.success(result?.payload?.message);
        setShowModal(false);
        setHighlightIndex(selectedindex);
        setEditIndex(null);
        setTimeout(() => {
          setHighlightIndex(null);
        }, 700);
      }
    } catch (error) {
      console.error("Error adding portfolio:", error);
      toast.error(error.message);
    }
  };
  useEffect(() => {
    blurLegends();
    setChartData((prev) => ({
      ...prev,
      options: {
        ...prev.options,
        legend: {
          ...prev.options.legend,
          labels: {
            ...prev.options.legend?.labels,
            colors: theme === "dark" ? "#e5e7eb" : "#374151",
          },
        },
      },
    }));
  }, [theme]);

  useEffect(() => {
    const list = userPortfolio?.stocks;
    if (!Array.isArray(list) || list.length === 0) return;

    const labels = list.map((item) => item.symbol);
    const series = list.map((item) => Number(item.invested));
    const colors = labels.map((symbol) => symbolColors[symbol]);

    setChartData((prev) => ({
      ...prev,
      series,
      options: {
        ...prev.options,
        labels,
        colors, // ✅ FIXED
      },
    }));
  }, [userPortfolio?.stocks, theme]);
  return (
    <Layout>
      <div className="d-none">
        <section id="user-portfolio" className="py-5">
          <div className="container">
            <div className="row g-3 align-items-center mb-5">
              <div className="col-12 col-md-6">
                <div className="d-flex align-items-baseline gap-2">
                  <h4 className="mb-0 fw-bold">Alpha India Portfolio</h4>
                  <small className="fw-normal text-muted">
                    (
                    {userPortfolio?.stocks?.length > 0
                      ? userPortfolio?.stocks?.length
                      : 0}{" "}
                    Stocks)
                  </small>
                </div>
                <p>A model portfolio created for an investment of ₹10,00,000</p>
              </div>

              <div className="col-12 col-md-6 d-flex justify-content-start justify-content-md-end ">
                <button
                  className="btn btn-dark"
                  type="button"
                  onClick={() => {
                    localStorage.removeItem("selectedPortfolio");
                    window.open("https://equitypandit.in/portfolio", "_blank");
                  }}
                >
                  <div className="d-flex gap-2 justify-content-center align-items-center">
                    <i class="fa fa-lock" aria-hidden="true"></i>
                    <span>Unlock Now</span>
                  </div>
                </button>
              </div>

              <div className="col-md-8">
                <div className="row g-3 align-items-center">
                  <div className="col-md-4 col-6 d-md-block d-none">
                    <small className="text-muted d-block">Allocated Fund</small>
                    <h4 className="mb-0">
                      {userPortfolio?.portfolioAmt?.toLocaleString("en-IN")}
                    </h4>
                  </div>
                  <div className="col-md-4 col-6">
                    <small className="text-muted d-block">Invested</small>
                    <h4 className="mb-0">
                      {userPortfolio?.totalInvestedAmt?.toLocaleString("en-IN")}
                    </h4>
                  </div>
                  <div className="col-md-4 col-6 d-md-block d-none">
                    <small className="text-muted d-block">
                      Available Funds
                    </small>
                    <h4 className="mb-0">
                      {(
                        userPortfolio?.portfolioAmt -
                        userPortfolio?.totalInvestedAmt
                      )?.toLocaleString("en-IN")}
                    </h4>
                  </div>
                  <div className="col-md-4 col-6">
                    <small className="text-muted d-block">Current Value</small>
                    <h4 className="mb-0">
                      {userPortfolio?.totalCurrentValue?.toLocaleString(
                        "en-IN",
                      )}
                    </h4>
                  </div>
                  <div className="col-md-4 col-6">
                    <small className="text-muted d-block">Overall P&L</small>
                    <div className="d-flex align-items-baseline gap-2">
                      <h4
                        className={`${userPortfolio?.totalPnL >= 0 ? "text-success" : "text-danger"} mb-0`}
                      >
                        {userPortfolio?.totalPnL >= 0 ? "" : "-"}
                        {/* {userPortfolio?.totalPnL?.toFixed(2)} */}
                        {Math.abs(userPortfolio?.totalPnL || 0).toLocaleString(
                          "en-IN",
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          },
                        )}
                      </h4>
                      <small
                        className={`${userPortfolio?.totalPnL >= 0 ? "text-success" : "text-danger"}`}
                      >
                        ({userPortfolio?.totalNetChange || 0})
                      </small>
                    </div>
                  </div>
                  <div className="col-md-4 col-6">
                    <small className="text-muted d-block">Day's P&L</small>
                    <div className="d-flex align-items-baseline gap-2">
                      <h4
                        className={`${userPortfolio?.totalDayProfit >= 0 ? "text-success" : "text-danger"} mb-0`}
                      >
                        {userPortfolio?.totalDayProfit >= 0 ? "" : "-"}
                        {/* {userPortfolio?.totalDayProfit?.toFixed(2)} */}
                        {Math.abs(
                          userPortfolio?.totalDayProfit || 0,
                        ).toLocaleString("en-IN", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </h4>
                      <small
                        className={`${userPortfolio?.totalDayProfit >= 0 ? "text-success" : "text-danger"}`}
                      >
                        ({userPortfolio?.todayNetChange || 0}%)
                      </small>
                    </div>
                  </div>
                </div>
              </div>

              {/* <!-- Pie chart --> */}
              <div className="col-md-4 col-12">
                <div className="mt-3">
                  <Chart
                    options={chartData.options}
                    series={chartData.series}
                    type="donut"
                    // height={1050}
                    width={350}
                  />
                </div>
              </div>

              {/* <!-- Legend --> */}
              {/* <div className="col-md-2 col-6">
                  <div id="portfolioPieLegend" className="pie-legend ms-md-2 mt-3 mt-md-0"></div>
                </div> */}
            </div>
            {portFolioList?.length > 0 &&
              portFolioList?.map((stock, index) => (
                <div className="p-3 alert alert-primary">
                  <div className="row g-3 align-items-center">
                    <div className="col-md-7 col-12">
                      <small className="mb-0">
                        <i className="fa fa-triangle-exclamation"></i> Buy Alert
                        : BUY {stock.symbol}, Qty: {stock.qty}, CMP:{" "}
                        {stock.ltp != null
                          ? Number(stock.ltp).toLocaleString("en-IN", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                          : "--"}
                      </small>
                    </div>
                    <div className="col-md-3 col-7">
                      <input
                        type="number"
                        className={`form-control ${errors[index]?.price ? "is-invalid" : ""}`}
                        id="rebalancing-alert-shown"
                        placeholder="Your entry price"
                        value={inputs[index]?.price || ""}
                        onChange={(e) =>
                          handleInputChange(
                            index,
                            "price",
                            e.target.value,
                            Math.floor(stock.allocation_amount / stock.ltp),
                          )
                        }
                      />
                      {errors[index]?.price && (
                        <div className="invalid-feedback">
                          {errors[index].price}
                        </div>
                      )}
                    </div>
                    <div className="col-md-2 col-5">
                      <button
                        className="btn btn-sm btn-dark"
                        onClick={() => handleAdd(stock, index)}
                      >
                        Confirm Buy
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            <div className="p-3 alert alert-warning d-none">
              <div className="row g-3 align-items-center">
                <div className="col-md-7 col-12">
                  <small className="mb-0">
                    <i className="fa fa-triangle-exclamation"></i> Sell Alert :
                    Sell SBIN, Qty: 25, CMP: 1,005.75
                  </small>
                </div>
                <div className="col-md-3 col-7">
                  <input
                    type="number"
                    className="form-control"
                    id="rebalancing-alert-shown"
                    placeholder="Your exit price"
                  />
                </div>
                <div className="col-md-2 col-5">
                  <button className="btn btn-sm btn-dark">Confirm Sell</button>
                </div>
              </div>
            </div>

            {/* <!-- Table header (desktop) --> */}
            <div className="p-3 rounded-3 bg-dark text-light d-none d-md-block">
              <div className="row g-3">
                <div className="col-md-1">
                  <span>Scrip</span>
                </div>
                <div className="col-md-2 text-end">
                  <span>Invested</span>
                </div>
                <div className="col-md-2 text-end">
                  <span>Current Val.</span>
                </div>
                <div className="col-md-2 text-end">
                  <span>Avg. Price</span>
                </div>
                <div className="col-md-2 text-end">
                  <span>Total P&L</span>
                </div>
                <div className="col-md-1 text-end">
                  <span>CMP</span>
                </div>
                <div className="col-md-2 text-end">
                  <span>1 Day P&L</span>
                </div>
              </div>
            </div>

            {/* <!-- Rows --> */}
            {portFolioList?.stocks?.length > 0 &&
              portFolioList?.stocks?.map((stock, idx) => (
                <div
                  className="p-3 rounded-3 bg-light text-dark my-2"
                  key={idx}
                >
                  <div className="row g-2 align-items-center">
                    <div className="col-md-1 col-12">
                      <div className="d-flex align-items-center gap-2">
                        <BlurredText blur={4}>
                          <i
                            className="fa fa-circle"
                            style={{
                              color: symbolColors[stock.symbol],
                              fontSize: "10px",
                            }}
                          ></i>
                        </BlurredText>
                        <BlurredText blur={4}>{"xxxxxxx"}</BlurredText>
                      </div>
                      <small className="d-block">
                        <small className="text-muted d-block">
                          <i className="fas fa-briefcase"></i>{" "}
                          {stock.qty?.toLocaleString("en-IN")}
                        </small>
                      </small>
                    </div>
                    <div className="col-md-2 col-6">
                      <div className="text-start text-md-end">
                        <small>
                          <small className="d-block d-md-none text-muted">
                            Invested
                          </small>
                        </small>
                        <span>
                          {stock.invested != null
                            ? Number(stock.invested).toLocaleString("en-IN", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                            : "--"}
                        </span>
                      </div>
                    </div>
                    <div className="col-md-2 col-6">
                      <div className="text-end">
                        <small>
                          <small className="d-block d-md-none text-muted">
                            Current Val.
                          </small>
                        </small>
                        <span>
                          {stock.currentVal != null
                            ? Number(stock.currentVal).toLocaleString("en-IN", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                            : "--"}
                        </span>
                      </div>
                    </div>
                    <div className="col-md-2 col-4">
                      <div className="text-start text-md-end">
                        {/* Mobile Label */}
                        <small className="d-block d-md-none text-muted mb-1">
                          Avg. Price
                        </small>

                        {editIndex === idx ? (
                          <div className="d-flex align-items-center justify-content-start gap-2">
                            <div>
                              <input
                                type="number"
                                className={`form-control form-control-sm text-end ${
                                  errors[idx]?.price ? "is-invalid" : ""
                                }`}
                                style={{ width: "120px" }}
                                value={inputs[idx]?.price ?? stock.avgPrice}
                                onChange={(e) =>
                                  handleInputChange(
                                    idx,
                                    "price",
                                    e.target.value,
                                    Math.floor(
                                      stock.allocation_amount / stock.ltp,
                                    ),
                                  )
                                }
                              />
                            </div>

                            <button
                              type="button"
                              className="btn btn-sm btn-link text-success p-2"
                              style={{
                                minWidth: "40px",
                                minHeight: "40px",
                                zIndex: 10,
                              }}
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();

                                const finalData = {
                                  investedAmt:
                                    inputs[idx]?.price *
                                    (stock.qty || stock?.recQty),
                                  allocation: stock.allocation,
                                  portfolioId: stock.portfolioId,
                                  coCode: stock.coCode,
                                  symbol: stock.symbol,
                                  avgPrice: inputs[idx]?.price,
                                  qty: stock.qty || stock?.recQty,
                                  id: stock.id,
                                  isInitial: true,
                                };

                                handleSave(finalData);
                              }}
                            >
                              <i className="fa fa-save fs-5"></i>
                            </button>
                          </div>
                        ) : (
                          <div className="d-flex align-items-center justify-content-md-end gap-2">
                            {/* Price Display */}
                            <span>
                              {stock.recommendedPrice?.toLocaleString("en-IN")}
                            </span>

                            {/* Edit Button */}
                            <button
                              type="button"
                              className="btn btn-sm text-primary"
                              title="Edit"
                              onClick={() =>
                                toast.error(
                                  "You can not update the average price in model portfolio",
                                )
                              }
                              // onClick={() => {
                              //     setInputs((prev) => ({
                              //         ...prev,
                              //         [idx]: { price: stock.avgPrice, qty: stock.qty },
                              //     }));
                              //     setEditIndex(idx);
                              // }}
                            >
                              <i className="fa fa-edit"></i>
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="col-md-2 col-8">
                      <div className="text-end">
                        <small>
                          <small className="d-block d-md-none text-muted">
                            Total P&L
                          </small>
                        </small>
                        <span
                          className={`${stock.pl > 0 ? "text-success" : "text-danger"}`}
                        >
                          {stock.pl != null
                            ? Number(stock.pl).toLocaleString("en-IN", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                            : "--"}
                          <br className="d-none d-md-block" />
                          <small>
                            <small
                              className={`${stock?.plPercent >= 0 ? "text-success" : "text-danger"}`}
                            >
                              (
                              {stock.plPercent != null
                                ? Number(stock.plPercent).toFixed(2)
                                : "--"}
                              %){" "}
                              <i
                                className={
                                  stock?.plPercent >= 0
                                    ? "fa fa-caret-up"
                                    : "fa fa-caret-down"
                                }
                              ></i>
                            </small>
                          </small>
                        </span>
                      </div>
                    </div>
                    <div className="col-md-1 col-4">
                      <div className="text-start text-md-end">
                        <small>
                          <small className="d-block d-md-none text-muted">
                            CMP
                          </small>
                        </small>
                        <span>
                          {stock.currentPrice?.toLocaleString("en-IN")}
                        </span>
                      </div>
                    </div>
                    <div className="col-md-2 col-8">
                      <div className="text-end">
                        <small>
                          <small className="d-block d-md-none text-muted">
                            Total P&L
                          </small>
                        </small>
                        <span
                          className={`${stock?.daysPlAmt > 0 ? "text-success" : "text-danger"}`}
                        >
                          {stock?.daysPlAmt != null
                            ? Number(stock?.daysPlAmt).toLocaleString("en-IN", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                            : "--"}
                          <br className="d-none d-md-block" />
                          <small>
                            <small
                              className={`${stock?.daysPlPercent >= 0 ? "text-success" : "text-danger"}`}
                            >
                              (
                              {stock?.daysPlPercent != null
                                ? Number(stock?.daysPlPercent).toFixed(2)
                                : "--"}
                              %){" "}
                              <i
                                className={
                                  stock?.daysPlPercent >= 0
                                    ? "fa fa-caret-up"
                                    : "fa fa-caret-down"
                                }
                              ></i>
                            </small>
                          </small>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>

          {/* <!-- Modal --> */}
          <div
            className="modal fade"
            id="exampleModal"
            tabIndex="-1"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
          >
            <div className="modal-dialog modal-sm">
              <div className="modal-content">
                <div className="modal-header">
                  <h1 className="modal-title fs-5" id="exampleModalLabel">
                    Edit Average Price
                  </h1>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="modal-body">
                  <div className="d-flex justify-content-between gap-3">
                    <div>
                      <small>Scrip</small>
                      <p className="fw-bold">SBIN</p>
                    </div>
                    <div>
                      <small>Current Avg. Price</small>
                      <p className="fw-bold">2498.85</p>
                    </div>
                  </div>
                  <div className="form-floating">
                    <input
                      type="number"
                      className="form-control fw-bold"
                      id="floatingInput"
                      placeholder="Enter New Avg. Price"
                    />
                    <label htmlFor="floatingInput">Enter New Avg. Price</label>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                  <button type="button" className="btn btn-primary">
                    Save Changes
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* <!-- Modal --> */}
        </section>
      </div>
      <section id="user-portfolio " class="py-4 d-none">
        <div class="container">
          <div class="row g-3 align-items-center mb-5">
            <div class="col-md-12">
              <a
                href="/dashboard"
                class="text-decoration-none text-body-emphasis fs-5"
              >
                <i class="fa fa-arrow-left"></i>
              </a>
            </div>
            <div class="col-md-8">
              <div class="mb-3">
                <h4 class="mb-0 fw-bold">Portfolio</h4>
                <small class="fw-normal text-muted">EP Portfolio</small>
              </div>

              <p>
                Subscribe To Alpha India Portfolio to View recommended Stocks
              </p>
              <div class="row g-3 align-items-center d-none">
                <div class="col-md-3 col-6">
                  <small class="text-muted d-block">Allocated Fund</small>
                  <h4 class="mb-0">2,00,000</h4>
                </div>
                <div class="col-md-3 col-6">
                  <small class="text-muted d-block">
                    Utilized <small class="text-muted">(98%)</small>
                  </small>
                  <h4 class="mb-0">1,98,000</h4>
                </div>
              </div>
              <button
                class="btn btn-dark"
                onClick={() => {
                  window.open("https://equitypandit.in/portfolio", "_blank");
                  localStorage.removeItem("selectedPortfolio");
                }}
              >
                Subscribe Now
              </button>
            </div>
            
          </div>          
        </div>
      </section>
      <section id="user-portfolio" class="py-4">
        <div class="container">
            <div class="row justify-content-center justify-content-md-between g-3 align-items-center mb-5">
                <div class="col-md-12">
                    <a href="/dashboard" class="text-decoration-none text-body-emphasis fs-5"><i class="fa fa-arrow-left"></i></a>
                </div>

                <div class="col-md-8">
                    <div class="row g-3 align-items-center">
                        <div class="col-md-12">
                            <div class="d-flex justify-content-start align-items-start gap-3">
                                <div>
                                    <h4 class="mb-1 fw-bold">Equity Portfolio</h4>
                                    <small class="fw-normal text-muted"><span style={{"filter":"blur(5px)"}}>XX</span>% Allocation</small>
                                </div>
                                <button class="btn btn-sm btn-dark" onClick={() => { window.open("https://equitypandit.in/pricing", "_blank"); localStorage.removeItem("selectedPortfolio"); }}><i class="fa fa-unlock"></i> Unlock Now</button>
                            </div>
                        </div>
                        <div class="col-md-3 col-6"><small class="text-muted d-block">Invested</small>
                            <h4 class="mb-0" style={{"filter":"blur(5px)"}}>XX,XX,XXX</h4>
                        </div>
                        <div class="col-md-3 col-6"><small class="text-muted d-block">Current Value</small>
                            <h4 class="mb-0" style={{"filter":"blur(5px)"}}>XX,XX,XXX</h4>
                        </div>
                        <div class="col-md-3 col-6"><small class="text-muted d-block">Current P&L</small>
                            <div class="d-flex align-items-baseline gap-2">
                                <h4 class="text-success mb-0" style={{"filter":"blur(5px)"}}>+X,XX,XXX</h4><small class="text-success" style={{"filter":"blur(5px)"}}>(+xx.xx%)</small>
                            </div>
                        </div>
                        <div class="col-md-3 col-6"><small class="text-muted d-block">Day's P&L</small>
                            <div class="d-flex align-items-baseline gap-2">
                                <h4 class="text-success mb-0" style={{"filter":"blur(5px)"}}>+X,XXX</h4><small class="text-success" style={{"filter":"blur(5px)"}}>(+xx.xx)</small>
                            </div>
                        </div>
                        <div class="col-md-3 col-6"><small class="text-muted d-block">Booked P&amp;L</small>
                            <div class="d-flex align-items-baseline gap-2">
                                <h4 class="text-success mb-0" style={{"filter":"blur(5px)"}}>X,XX,XXX</h4>
                            </div>
                        </div>
                        <div class="col-md-3 col-6"><small class="text-muted d-block">Overall P&amp;L</small>
                            <div class="d-flex align-items-baseline gap-2">
                                <h4 class="text-success mb-0" style={{"filter":"blur(5px)"}}>+X,XX,XXX</h4><small class="text-success" style={{"filter":"blur(5px)"}}>(+xx.xx%)</small>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!-- Pie chart --> */}
                <div class="col-md-2 col-6 ">
                    <div class="d-flex justify-content-center">
                        {/* <!-- <div class="ratio ratio-1x1"> --> */}
                        <canvas id="portfolioPieChart"></canvas>
                        {/* <!-- </div> --> */}
                    </div>
                </div>
                {/* <!-- Legend --> */}
                <div class="col-md-2 col-6 ">
                    <div id="portfolioPieLegend" class="pie-legend ms-md-2 my-3 mt-md-0"></div>
                </div>
            </div>

            <div class="alert alert-primary d-inline-block">
                <small><i class="fa fa-triangle-exclamation"></i> Buy Alert : BUY <span style={{"filter":"blur(5px)"}}>XXXX</span>, <i class="fa fa-briefcase"></i> Qty: <span style={{"filter":"blur(5px)"}}>xxxx</span>, CMP: <span style={{"filter":"blur(5px)"}}>XXX.XX</span></small>
            </div>
            <div class="alert alert-warning d-inline-block">
                <small><i class="fa fa-triangle-exclamation"></i> Sell Alert : SELL <span style={{"filter":"blur(5px)"}}>XXXX</span>, <i class="fa fa-briefcase"></i> Qty: <span style={{"filter":"blur(5px)"}}>xxxx</span>, CMP: <span style={{"filter":"blur(5px)"}}>XXX.XX</span></small>
            </div>

            <div class="d-flex align-items-baseline">
                <h5 class="mb-1 fw-bold">Open Recommendations</h5>
                <small class="text-muted ms-2">(<span style={{"filter":"blur(5px)"}}>XX</span> Stocks)</small>
            </div>
            <small class="fw-normal text-muted d-block mb-3">As on {moment().format("DD MMM, YYYY")}</small>


            {/* <!-- Table header (desktop) --> */}
            <div class="p-3 rounded-3 bg-dark text-light d-none d-md-block">
                <div class="row g-3">
                    <div class="col-md-3">
                        <span>Scrip</span>
                    </div>
                    <div class="col-md-2 text-end">
                        <span>Invested & Current Val.</span>
                    </div>
                    <div class="col-md-2 text-end">
                        <span>Avg. Price & CMP</span>
                    </div>
                    <div class="col-md-2 text-end">
                        <span>1 Day P&L</span>
                    </div>
                    <div class="col-md-2 text-end">
                        <span>Total P&L</span>
                    </div>
                </div>
            </div>

            {/* <!-- Rows --> */}
                            <div class="p-3 rounded-3 bg-light text-dark my-2">
                    <div class="row g-3 align-items-center">
                        <div class="col-md-3 col-12">
                            <div class="">
                                <i class="fa fa-circle fa-2xs" style={{"color": "#4285F4"}}></i> <span class="me-2" style={{"filter":"blur(5px)"}}>XXXXXX</span>
                                <br class="d-none d-md-block" />
                                <small class="">
                                    <small class="text-muted">
                                        <i class="fa fa-briefcase"></i> <span style={{"filter":"blur(5px)"}}>xxxx</span> Shares
                                    </small>
                                </small>
                            </div>
                        </div>
                        <div class="col-md-2 col-6">
                            <div class="text-start text-md-end">
                                <small><small class="d-block d-md-none text-muted">Invested</small></small>
                                <span style={{"filter":"blur(5px)"}}>X,XX,XXX</span>
                                <small class="d-block mt-2 mt-md-0"><small class="d-block d-md-none text-muted">Current Val.</small></small>
                                <span class="text-success" style={{"filter":"blur(5px)"}}>X,XX,XXX</span>
                            </div>
                        </div>
                        <div class="col-md-2 col-6">
                            <div class="text-end">
                                <small><small class="d-block d-md-none text-muted">Avg. Price</small></small>
                                <span style={{"filter":"blur(5px)"}}>X,XXX</span>
                                <small class="d-block mt-2 mt-md-0"><small class="d-block d-md-none text-muted">CMP</small></small>
                                <span class="text-success d-block" style={{"filter":"blur(5px)"}}>X,XXX</span>
                            </div>
                        </div>
                        <div class="col-md-2 col-6">
                            <div class="text-start text-md-end">
                                <small><small class="d-block d-md-none text-muted">1 Day P&L</small></small>
                                <span class="text-success" style={{"filter":"blur(5px)"}}>X,XXX<br/>
                                    <small>(+xx.xx%) <i class="fa-solid fa-caret-up" aria-hidden="true"></i></small>
                                </span>
                            </div>
                        </div>
                        <div class="col-md-2 col-6">
                            <div class="text-end">
                                <small><small class="d-block d-md-none text-muted">Total P&amp;L</small></small>
                                <span class="text-success" style={{"filter":"blur(5px)"}}>X,XX,XXX<br/>
                                    <small>(+xx.xx%) <i class="fa-solid fa-caret-up" aria-hidden="true"></i></small>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                            <div class="p-3 rounded-3 bg-light text-dark my-2">
                    <div class="row g-3 align-items-center">
                        <div class="col-md-3 col-12">
                            <div class="">
                                <i class="fa fa-circle fa-2xs" style={{"color": "#DB4437"}}></i> <span class="me-2" style={{"filter":"blur(5px)"}}>XXXXXX</span>
                                <br class="d-none d-md-block" />
                                <small class="">
                                    <small class="text-muted">
                                        <i class="fa fa-briefcase"></i> <span style={{"filter":"blur(5px)"}}>xxxx</span> Shares
                                    </small>
                                </small>
                            </div>
                        </div>
                        <div class="col-md-2 col-6">
                            <div class="text-start text-md-end">
                                <small><small class="d-block d-md-none text-muted">Invested</small></small>
                                <span style={{"filter":"blur(5px)"}}>X,XX,XXX</span>
                                <small class="d-block mt-2 mt-md-0"><small class="d-block d-md-none text-muted">Current Val.</small></small>
                                <span class="text-success" style={{"filter":"blur(5px)"}}>X,XX,XXX</span>
                            </div>
                        </div>
                        <div class="col-md-2 col-6">
                            <div class="text-end">
                                <small><small class="d-block d-md-none text-muted">Avg. Price</small></small>
                                <span style={{"filter":"blur(5px)"}}>X,XXX</span>
                                <small class="d-block mt-2 mt-md-0"><small class="d-block d-md-none text-muted">CMP</small></small>
                                <span class="text-success d-block" style={{"filter":"blur(5px)"}}>X,XXX</span>
                            </div>
                        </div>
                        <div class="col-md-2 col-6">
                            <div class="text-start text-md-end">
                                <small><small class="d-block d-md-none text-muted">1 Day P&L</small></small>
                                <span class="text-success" style={{"filter":"blur(5px)"}}>X,XXX<br/>
                                    <small>(+xx.xx%) <i class="fa-solid fa-caret-up" aria-hidden="true"></i></small>
                                </span>
                            </div>
                        </div>
                        <div class="col-md-2 col-6">
                            <div class="text-end">
                                <small><small class="d-block d-md-none text-muted">Total P&amp;L</small></small>
                                <span class="text-success" style={{"filter":"blur(5px)"}}>X,XX,XXX<br/>
                                    <small>(+xx.xx%) <i class="fa-solid fa-caret-up" aria-hidden="true"></i></small>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                            <div class="p-3 rounded-3 bg-light text-dark my-2">
                    <div class="row g-3 align-items-center">
                        <div class="col-md-3 col-12">
                            <div class="">
                                <i class="fa fa-circle fa-2xs" style={{"color": "#F4B400"}}></i> <span class="me-2" style={{"filter":"blur(5px)"}}>XXXXXX</span>
                                <br class="d-none d-md-block" />
                                <small class="">
                                    <small class="text-muted">
                                        <i class="fa fa-briefcase"></i> <span style={{"filter":"blur(5px)"}}>xxxx</span> Shares
                                    </small>
                                </small>
                            </div>
                        </div>
                        <div class="col-md-2 col-6">
                            <div class="text-start text-md-end">
                                <small><small class="d-block d-md-none text-muted">Invested</small></small>
                                <span style={{"filter":"blur(5px)"}}>X,XX,XXX</span>
                                <small class="d-block mt-2 mt-md-0"><small class="d-block d-md-none text-muted">Current Val.</small></small>
                                <span class="text-success" style={{"filter":"blur(5px)"}}>X,XX,XXX</span>
                            </div>
                        </div>
                        <div class="col-md-2 col-6">
                            <div class="text-end">
                                <small><small class="d-block d-md-none text-muted">Avg. Price</small></small>
                                <span style={{"filter":"blur(5px)"}}>X,XXX</span>
                                <small class="d-block mt-2 mt-md-0"><small class="d-block d-md-none text-muted">CMP</small></small>
                                <span class="text-success d-block" style={{"filter":"blur(5px)"}}>X,XXX</span>
                            </div>
                        </div>
                        <div class="col-md-2 col-6">
                            <div class="text-start text-md-end">
                                <small><small class="d-block d-md-none text-muted">1 Day P&L</small></small>
                                <span class="text-success" style={{"filter":"blur(5px)"}}>X,XXX<br/>
                                    <small>(+xx.xx%) <i class="fa-solid fa-caret-up" aria-hidden="true"></i></small>
                                </span>
                            </div>
                        </div>
                        <div class="col-md-2 col-6">
                            <div class="text-end">
                                <small><small class="d-block d-md-none text-muted">Total P&amp;L</small></small>
                                <span class="text-success" style={{"filter":"blur(5px)"}}>X,XX,XXX<br/>
                                    <small>(+xx.xx%) <i class="fa-solid fa-caret-up" aria-hidden="true"></i></small>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                            <div class="p-3 rounded-3 bg-light text-dark my-2">
                    <div class="row g-3 align-items-center">
                        <div class="col-md-3 col-12">
                            <div class="">
                                <i class="fa fa-circle fa-2xs" style={{"color": "#0F9D58"}}></i> <span class="me-2" style={{"filter":"blur(5px)"}}>XXXXXX</span>
                                <br class="d-none d-md-block" />
                                <small class="">
                                    <small class="text-muted">
                                        <i class="fa fa-briefcase"></i> <span style={{"filter":"blur(5px)"}}>xxxx</span> Shares
                                    </small>
                                </small>
                            </div>
                        </div>
                        <div class="col-md-2 col-6">
                            <div class="text-start text-md-end">
                                <small><small class="d-block d-md-none text-muted">Invested</small></small>
                                <span style={{"filter":"blur(5px)"}}>X,XX,XXX</span>
                                <small class="d-block mt-2 mt-md-0"><small class="d-block d-md-none text-muted">Current Val.</small></small>
                                <span class="text-success" style={{"filter":"blur(5px)"}}>X,XX,XXX</span>
                            </div>
                        </div>
                        <div class="col-md-2 col-6">
                            <div class="text-end">
                                <small><small class="d-block d-md-none text-muted">Avg. Price</small></small>
                                <span style={{"filter":"blur(5px)"}}>X,XXX</span>
                                <small class="d-block mt-2 mt-md-0"><small class="d-block d-md-none text-muted">CMP</small></small>
                                <span class="text-success d-block" style={{"filter":"blur(5px)"}}>X,XXX</span>
                            </div>
                        </div>
                        <div class="col-md-2 col-6">
                            <div class="text-start text-md-end">
                                <small><small class="d-block d-md-none text-muted">1 Day P&L</small></small>
                                <span class="text-success" style={{"filter":"blur(5px)"}}>X,XXX<br/>
                                    <small>(+xx.xx%) <i class="fa-solid fa-caret-up" aria-hidden="true"></i></small>
                                </span>
                            </div>
                        </div>
                        <div class="col-md-2 col-6">
                            <div class="text-end">
                                <small><small class="d-block d-md-none text-muted">Total P&amp;L</small></small>
                                <span class="text-success" style={{"filter":"blur(5px)"}}>X,XX,XXX<br/>
                                    <small>(+xx.xx%) <i class="fa-solid fa-caret-up" aria-hidden="true"></i></small>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                            <div class="p-3 rounded-3 bg-light text-dark my-2">
                    <div class="row g-3 align-items-center">
                        <div class="col-md-3 col-12">
                            <div class="">
                                <i class="fa fa-circle fa-2xs" style={{"color": "#AB47BC"}}></i> <span class="me-2" style={{"filter":"blur(5px)"}}>XXXXXX</span>
                                <br class="d-none d-md-block" />
                                <small class="">
                                    <small class="text-muted">
                                        <i class="fa fa-briefcase"></i> <span style={{"filter":"blur(5px)"}}>xxxx</span> Shares
                                    </small>
                                </small>
                            </div>
                        </div>
                        <div class="col-md-2 col-6">
                            <div class="text-start text-md-end">
                                <small><small class="d-block d-md-none text-muted">Invested</small></small>
                                <span style={{"filter":"blur(5px)"}}>X,XX,XXX</span>
                                <small class="d-block mt-2 mt-md-0"><small class="d-block d-md-none text-muted">Current Val.</small></small>
                                <span class="text-success" style={{"filter":"blur(5px)"}}>X,XX,XXX</span>
                            </div>
                        </div>
                        <div class="col-md-2 col-6">
                            <div class="text-end">
                                <small><small class="d-block d-md-none text-muted">Avg. Price</small></small>
                                <span style={{"filter":"blur(5px)"}}>X,XXX</span>
                                <small class="d-block mt-2 mt-md-0"><small class="d-block d-md-none text-muted">CMP</small></small>
                                <span class="text-success d-block" style={{"filter":"blur(5px)"}}>X,XXX</span>
                            </div>
                        </div>
                        <div class="col-md-2 col-6">
                            <div class="text-start text-md-end">
                                <small><small class="d-block d-md-none text-muted">1 Day P&L</small></small>
                                <span class="text-success" style={{"filter":"blur(5px)"}}>X,XXX<br/>
                                    <small>(+xx.xx%) <i class="fa-solid fa-caret-up" aria-hidden="true"></i></small>
                                </span>
                            </div>
                        </div>
                        <div class="col-md-2 col-6">
                            <div class="text-end">
                                <small><small class="d-block d-md-none text-muted">Total P&amp;L</small></small>
                                <span class="text-success" style={{"filter":"blur(5px)"}}>X,XX,XXX<br/>
                                    <small>(+xx.xx%) <i class="fa-solid fa-caret-up" aria-hidden="true"></i></small>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>                
                    </div>
    </section>
    </Layout>
  );
}

export default MPortfolio;
